import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';

// import './fonts/inter/inter.css';
import './index.css';
import App from './components/App';

import {Provider} from 'react-redux';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';

import configureStore from './redux/configureStore';
import {decodeToken, getTokenFromLocalStorage} from './utils/auth';
import {ikey} from './config';

// import * as serviceWorker from './serviceWorker';

if (ikey) {
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: ikey
            /* ...Other Configuration Options... */
        }
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
}

const setUpInitialState = () => {
    let auth = getTokenFromLocalStorage();

    // decode user data from token
    if (auth.token) {
        let userData = decodeToken(auth.token);
        auth = {
            ...auth,
            ...userData
        };
    }

    return {auth};
};

const store = configureStore(setUpInitialState());

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <Router>
                <App/>
            </Router>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
